import React from "react";
import "./statCards.css";
import StatCard from "./statCard";

const StatCards = ({ statCardData }) => {
  return (
    <div className="statCards">
      {statCardData.map((data, index) => (
        <StatCard
          key={index}
          icon={data.icon}
          head={data.head}
          body={data.body}
        />
      ))}
    </div>
  );
};

export default StatCards;
